import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './containers/App';
// import 'antd/dist/antd.min.css';

const domNode = document.getElementById('app');
const root = createRoot(domNode);
root.render(<App />)